// extracted by mini-css-extract-plugin
export default {"search-input":"SearchInput_search-input__LyzcV"};